import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmojiLightbulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5507_94399)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M49.7696 99.8848C77.3618 99.8848 99.7696 77.4769 99.7696 49.8848C99.7696 22.2926 77.3618 -0.115234 49.7696 -0.115234C22.1774 -0.115234 -0.230408 22.2926 -0.230408 49.9424C-0.230408 77.5345 22.1198 99.8848 49.7696 99.8848Z",
				fill: "#1DBADF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.1222 9.73536C58.583 9.85057 58.9286 10.3114 58.8134 10.7722L57.3733 17.6271C57.2581 18.0879 56.7973 18.4335 56.3364 18.3183C55.8756 18.2031 55.53 17.7423 55.6452 17.2814L57.0277 10.369C57.1429 9.90818 57.6037 9.62016 58.1222 9.73536Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.1222 9.73536C58.583 9.85057 58.9286 10.3114 58.8134 10.7722L57.3733 17.6271C57.2581 18.0879 56.7973 18.4335 56.3364 18.3183C55.8756 18.2031 55.53 17.7423 55.6452 17.2814L57.0277 10.369C57.1429 9.90818 57.6037 9.62016 58.1222 9.73536Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71.4862 15.0926C71.8894 15.323 72.0046 15.899 71.7742 16.3022L68.0875 22.2354C67.8571 22.6387 67.2811 22.7539 66.8779 22.5234C66.4746 22.293 66.3594 21.717 66.5898 21.3138L70.2765 15.3806C70.5069 14.9198 71.0829 14.8046 71.4862 15.0926Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71.4862 15.0926C71.8894 15.323 72.0046 15.899 71.7742 16.3022L68.0875 22.2354C67.8571 22.6387 67.2811 22.7539 66.8779 22.5234C66.4746 22.293 66.3594 21.717 66.5898 21.3138L70.2765 15.3806C70.5069 14.9198 71.0829 14.8046 71.4862 15.0926Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.2581 24.6548C82.5461 25.058 82.4885 25.5765 82.0852 25.8645L76.6129 30.1848C76.2097 30.4728 75.6912 30.4152 75.4032 30.012C75.1152 29.6087 75.1728 29.0903 75.576 28.8023L81.0484 24.482C81.394 24.2516 81.9124 24.3092 82.2581 24.6548Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.2581 24.6548C82.5461 25.058 82.4885 25.5765 82.0852 25.8645L76.6129 30.1848C76.2097 30.4728 75.6912 30.4152 75.4032 30.012C75.1152 29.6087 75.1728 29.0903 75.576 28.8023L81.0484 24.482C81.394 24.2516 81.9124 24.3092 82.2581 24.6548Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M89.0553 37.3847C89.2281 37.8455 88.9401 38.364 88.4792 38.4792L81.8548 40.6681C81.394 40.8409 80.8756 40.5529 80.7603 40.0921C80.5875 39.6312 80.8756 39.1128 81.3364 38.9976L87.9608 36.8087C88.4216 36.6934 88.8825 36.9239 89.0553 37.3847Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M89.0553 37.3847C89.2281 37.8455 88.9401 38.364 88.4792 38.4792L81.8548 40.6681C81.394 40.8409 80.8756 40.5529 80.7603 40.0921C80.5875 39.6312 80.8756 39.1128 81.3364 38.9976L87.9608 36.8087C88.4216 36.6934 88.8825 36.9239 89.0553 37.3847Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.0714 51.6706C91.0714 52.1315 90.6682 52.5347 90.1498 52.5347L83.1797 52.3043C82.7189 52.3043 82.3157 51.901 82.3157 51.3826C82.3157 50.9218 82.7189 50.5186 83.2373 50.5186L90.2074 50.749C90.7258 50.749 91.129 51.1522 91.0714 51.6706Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.0714 51.6706C91.0714 52.1315 90.6682 52.5347 90.1498 52.5347L83.1797 52.3043C82.7189 52.3043 82.3157 51.901 82.3157 51.3826C82.3157 50.9218 82.7189 50.5186 83.2373 50.5186L90.2074 50.749C90.7258 50.749 91.129 51.1522 91.0714 51.6706Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.8203 49.3083C16.8203 49.7692 16.417 50.1724 15.8986 50.1724L8.92857 49.942C8.46774 49.942 8.06451 49.5387 8.06451 49.0203C8.06451 48.5595 8.46774 48.1562 8.98617 48.1562L15.9562 48.3867C16.4747 48.4443 16.8203 48.8475 16.8203 49.3083Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.8203 49.3083C16.8203 49.7692 16.417 50.1724 15.8986 50.1724L8.92857 49.942C8.46774 49.942 8.06451 49.5387 8.06451 49.0203C8.06451 48.5595 8.46774 48.1562 8.98617 48.1562L15.9562 48.3867C16.4747 48.4443 16.8203 48.8475 16.8203 49.3083Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.1337 65.7839C87.9609 66.2447 87.4424 66.4751 86.9816 66.2447L80.53 63.6525C80.0692 63.4797 79.8387 62.9613 80.0692 62.5004C80.242 62.0396 80.7604 61.8092 81.2212 62.0396L87.6728 64.6318C88.1337 64.8046 88.3065 65.323 88.1337 65.7839Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.1337 65.7839C87.9609 66.2447 87.4424 66.4751 86.9816 66.2447L80.53 63.6525C80.0692 63.4797 79.8387 62.9613 80.0692 62.5004C80.242 62.0396 80.7604 61.8092 81.2212 62.0396L87.6728 64.6318C88.1337 64.8046 88.3065 65.323 88.1337 65.7839Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.1821 38.1911C19.0092 38.6519 18.4908 38.8823 18.03 38.6519L11.5208 36.0597C11.0599 35.8869 10.8295 35.3685 11.0599 34.9077C11.2327 34.4468 11.7512 34.2164 12.212 34.4468L18.6636 37.039C19.1245 37.2118 19.3549 37.7303 19.1821 38.1911Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.1821 38.1911C19.0092 38.6519 18.4908 38.8823 18.03 38.6519L11.5208 36.0597C11.0599 35.8869 10.8295 35.3685 11.0599 34.9077C11.2327 34.4468 11.7512 34.2164 12.212 34.4468L18.6636 37.039C19.1245 37.2118 19.3549 37.7303 19.1821 38.1911Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.1728 28.514C24.8272 28.8596 24.3088 28.9172 23.9055 28.5716L18.7212 23.9057C18.3756 23.5601 18.318 23.0417 18.6636 22.6384C19.0092 22.2928 19.5277 22.2352 19.9309 22.5808L25.1152 27.2467C25.4608 27.5924 25.4608 28.1108 25.1728 28.514Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.1728 28.514C24.8272 28.8596 24.3088 28.9172 23.9055 28.5716L18.7212 23.9057C18.3756 23.5601 18.318 23.0417 18.6636 22.6384C19.0092 22.2928 19.5277 22.2352 19.9309 22.5808L25.1152 27.2467C25.4608 27.5924 25.4608 28.1108 25.1728 28.514Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.1014 21.4862C33.6982 21.7166 33.1222 21.5438 32.8917 21.1405L29.6083 14.9769C29.3779 14.5737 29.5507 13.9977 29.954 13.7673C30.3572 13.5369 30.9332 13.7097 31.1636 14.1129L34.447 20.2765C34.6775 20.6797 34.5622 21.2557 34.1014 21.4862Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.1014 21.4862C33.6982 21.7166 33.1222 21.5438 32.8917 21.1405L29.6083 14.9769C29.3779 14.5737 29.5507 13.9977 29.954 13.7673C30.3572 13.5369 30.9332 13.7097 31.1636 14.1129L34.447 20.2765C34.6775 20.6797 34.5622 21.2557 34.1014 21.4862Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.9309 17.9144C44.47 17.972 44.0092 17.6264 43.9516 17.1656L42.9723 10.2531C42.9147 9.79229 43.2604 9.33146 43.7212 9.27386C44.182 9.21626 44.6429 9.56188 44.7005 10.0227L45.6797 16.9351C45.7373 17.396 45.3917 17.8568 44.9309 17.9144Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.9309 17.9144C44.47 17.972 44.0092 17.6264 43.9516 17.1656L42.9723 10.2531C42.9147 9.79229 43.2604 9.33146 43.7212 9.27386C44.182 9.21626 44.6429 9.56188 44.7005 10.0227L45.6797 16.9351C45.7373 17.396 45.3917 17.8568 44.9309 17.9144Z",
				stroke: "#FFD525",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.2074 21.5441C50.4608 18.5487 61.5208 20.8528 69.7005 27.7076C76.2673 33.18 82.0853 42.1086 79.2051 55.8759C75.1728 75.1731 55.7604 74.4818 53.1106 87.097L42.1659 85.5417L31.5092 82.604C34.159 69.9311 16.0714 62.8459 20.1037 43.5487C23.0991 29.7814 32.0277 23.9634 40.2074 21.5441Z",
				fill: "#FFD525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.1682 87.0966L50.2304 98.7902C50.1152 99.251 49.6544 99.539 49.1935 99.4814L29.3203 95.3339C28.8594 95.2187 28.5714 94.7579 28.629 94.2971L31.5668 82.6035L53.1682 87.0966Z",
				fill: "#DBDBDB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.1682 87.0965L50.6336 99.1933C50.5184 99.6541 50.0576 99.9422 49.5967 99.8846L47.811 99.4813L50.5184 86.5205L53.1682 87.0965Z",
				fill: "#CFCFCF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.4783 80.6292L30.054 82.6592L54.5829 87.786L55.0072 85.756L30.4783 80.6292Z",
				fill: "#DBDBDB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.3583 85.0105L29.9576 86.9277L53.0204 91.7481L53.4211 89.8309L30.3583 85.0105Z",
				fill: "#939CAC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.493 89.033L29.0923 90.9502L52.1551 95.7706L52.5558 93.8534L29.493 89.033Z",
				fill: "#939CAC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.6394 92.9988L28.2386 94.916L51.3014 99.7364L51.7022 97.8192L28.6394 92.9988Z",
				fill: "#939CAC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.447 54.263L48.0414 56.3943C48.5023 56.4519 48.7327 57.0279 48.5023 57.4312C48.2142 57.8344 47.811 58.3528 47.2926 58.8713C45.9101 60.2537 43.6635 61.5786 40.3225 61.0602C40.0345 61.0026 39.7465 60.945 39.5161 60.8874C35.599 59.9081 34.1589 56.7399 33.6981 55.127C33.5829 54.6086 33.9861 54.1477 34.447 54.263Z",
				fill: "#27385A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.5737 60.5411C39.5737 60.6563 39.5737 60.7715 39.5737 60.8868C39.8617 60.9444 40.0922 61.002 40.3802 61.0596C43.7212 61.578 45.9677 60.1955 47.3502 58.8706C46.659 58.525 45.9101 58.237 45.0461 58.0642C42.2811 57.6033 39.8617 58.6978 39.5737 60.5411Z",
				fill: "#FF2180"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.4977 56.9126C51.2673 58.4679 52.5346 60.0232 54.4355 60.3112C56.2788 60.5992 58.0069 59.5624 58.2373 58.0071C58.4677 56.4518 57.2005 54.8965 55.2995 54.6085C53.4562 54.2628 51.7281 55.2997 51.4977 56.9126Z",
				fill: "#FF2180"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.3087 52.65C24.0783 54.2053 25.3456 55.7606 27.2465 56.0487C29.0898 56.3367 30.8179 55.2998 31.0484 53.7445C31.2788 52.1892 30.0115 50.6339 28.1106 50.3459C26.2673 50.0579 24.5391 51.0947 24.3087 52.65Z",
				fill: "#FF2180"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.8663 50.4608C37.0392 50.5184 37.2696 50.4608 37.4424 50.3456C37.7304 50.1727 37.788 49.8271 37.7304 49.4815C36.5783 45.6797 33.2949 44.2396 33.1797 44.182C32.7765 44.0092 32.3733 44.182 32.2004 44.5852C32.0276 44.9884 32.2004 45.3916 32.6037 45.5645C32.6613 45.5645 34.2166 46.2557 35.3687 47.9262C33.2373 47.1197 31.2788 47.1198 31.1636 47.1198C30.7604 47.1198 30.4147 47.4654 30.4147 47.8686C30.4147 48.2718 30.7604 48.6174 31.1636 48.6174C31.1636 48.6174 34.2166 48.6174 36.5783 50.2303C36.6359 50.4032 36.7511 50.4032 36.8663 50.4608Z",
				fill: "#27385A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.8663 50.4608C37.0392 50.5184 37.2696 50.4608 37.4424 50.3456C37.7304 50.1727 37.788 49.8271 37.7304 49.4815C36.5783 45.6797 33.2949 44.2396 33.1797 44.182C32.7765 44.0092 32.3733 44.182 32.2004 44.5852C32.0276 44.9884 32.2004 45.3916 32.6037 45.5645C32.6613 45.5645 34.2166 46.2557 35.3687 47.9262C33.2373 47.1197 31.2788 47.1198 31.1636 47.1198C30.7604 47.1198 30.4147 47.4654 30.4147 47.8686C30.4147 48.2718 30.7604 48.6174 31.1636 48.6174C31.1636 48.6174 34.2166 48.6174 36.5783 50.2303C36.6359 50.4032 36.7511 50.4032 36.8663 50.4608Z",
				stroke: "#27385A",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.947 52.0159C47.0622 52.0159 47.1774 52.0159 47.2926 52.0159C50.0576 51.1519 52.9378 52.1311 52.9378 52.1311C53.341 52.2463 53.7442 52.0735 53.917 51.6703C54.0322 51.2671 53.8594 50.8639 53.4562 50.691C53.341 50.6334 51.4977 50.0574 49.1935 50.1726C50.8064 48.9053 52.5345 48.7325 52.5345 48.7325C52.9378 48.6749 53.2834 48.3293 53.2258 47.9261C53.1682 47.5228 52.8226 47.1772 52.4193 47.2348C52.2465 47.2348 48.7327 47.638 46.4286 50.8639C46.2557 51.1519 46.2557 51.4975 46.4286 51.7279C46.5438 51.8431 46.7166 51.9583 46.947 52.0159Z",
				fill: "#27385A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.947 52.0159C47.0622 52.0159 47.1774 52.0159 47.2926 52.0159C50.0576 51.1519 52.9378 52.1311 52.9378 52.1311C53.341 52.2463 53.7442 52.0735 53.917 51.6703C54.0322 51.2671 53.8594 50.8639 53.4562 50.691C53.341 50.6334 51.4977 50.0574 49.1935 50.1726C50.8064 48.9053 52.5345 48.7325 52.5345 48.7325C52.9378 48.6749 53.2834 48.3293 53.2258 47.9261C53.1682 47.5228 52.8226 47.1772 52.4193 47.2348C52.2465 47.2348 48.7327 47.638 46.4286 50.8639C46.2557 51.1519 46.2557 51.4975 46.4286 51.7279C46.5438 51.8431 46.7166 51.9583 46.947 52.0159Z",
				stroke: "#27385A",
				strokeMiterlimit: 10
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5507_94399",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 100,
			fill: "white"
		})
	}) })]
});
export default SvgEmojiLightbulb;
